export default function selectSelectedText (selector$) {
  const selectedOption = selector$.find('option:selected').expectLength()
  const value = selectedOption.val()

  const ret = value ? selectedOption.text() : null
  return ret
}
